module.exports = __webpack_public_path__ + "static/media/black-restaurant-icon.64acc12b.svg";